// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"b0a1c18e","190":"3d7bf889","278":"d175f528","417":"e9db522a","464":"d86467b7","689":"f8c8d297","743":"4301b1aa","748":"458112fe"}[chunkId] + ".chunk.js";
};